const DLSITE_CATEGORY_PATTERN =
  "soft|home|maniax|girls|bl|goods|books|pro|eng|aix";
const DLSITE_PRODUCT_PATTERN = new RegExp(
  `^/(${DLSITE_CATEGORY_PATTERN})(?:-touch)?/.*product_id/([a-z]+[0-9]+)\\.html$`,
  "i",
);
const DLSITE_PROMOTION_PATTERN = new RegExp(
  `^/(${DLSITE_CATEGORY_PATTERN})(?:-touch)?/(?:campaign|discount)/.*$`,
  "i",
);

const DLSITE_AFFILIATE_ID = "futabachan";
const FANZA_AFFILIATE_ID = "futabachan-001";
const DIGIKET_AFFILIATE_ID = "nijiaimg";

function decodeLegacyUrlEntities(value: string): string {
  return value
    .replaceAll("&amp;", "&")
    .replaceAll("&lt;", "<")
    .replaceAll("&gt;", ">")
    .replaceAll("&quot;", '"');
}

function parseHttpUrl(value: string): URL | null {
  if (value.trim() !== value) {
    return null;
  }
  try {
    const url = new URL(value);
    if (
      (url.protocol !== "http:" && url.protocol !== "https:") ||
      url.username !== "" ||
      url.password !== "" ||
      url.port !== ""
    ) {
      return null;
    }
    return url;
  } catch {
    return null;
  }
}

function hasExactHost(url: URL, hosts: readonly string[]): boolean {
  return hosts.includes(url.hostname.toLowerCase());
}

function hasBaseDomain(url: URL, baseDomain: string): boolean {
  const hostname = url.hostname.toLowerCase();
  return hostname === baseDomain || hostname.endsWith(`.${baseDomain}`);
}

function convertDlsiteUrl(original: string, url: URL): string | null {
  const isDlsite = hasExactHost(url, ["dlsite.com", "www.dlsite.com"]);
  const isDlsharing = hasExactHost(url, ["dlsharing.com", "www.dlsharing.com"]);
  if (!isDlsite && !isDlsharing) {
    return null;
  }

  const productMatch = url.pathname.match(DLSITE_PRODUCT_PATTERN);
  if (productMatch !== null) {
    const category = productMatch[1];
    const productId = productMatch[2];
    if (category === undefined || productId === undefined) {
      return null;
    }
    return `https://dlaf.jp/${category.toLowerCase()}/dlaf/=/t/s/link/work/aid/${DLSITE_AFFILIATE_ID}/id/${productId.toUpperCase()}.html`;
  }

  if (isDlsite) {
    const category = url.pathname.match(DLSITE_PROMOTION_PATTERN)?.[1];
    if (category !== undefined) {
      const decodedUrl = decodeLegacyUrlEntities(original);
      return `https://dlaf.jp/${category.toLowerCase()}/dlaf/=/aid/${DLSITE_AFFILIATE_ID}/url/${encodeURIComponent(decodedUrl)}`;
    }
  }
  return null;
}

function convertDmmUrl(original: string, url: URL): string | null {
  const isDmmFamily = ["dmm.co.jp", "dmm.com", "fanza.com"].some((domain) =>
    hasBaseDomain(url, domain),
  );
  const hasExplicitPath =
    /^https?:\/\/(?:[a-z0-9-]+\.)*(?:dmm\.co\.jp|dmm\.com|fanza\.com)\//i.test(
      original,
    );
  if (
    !isDmmFamily ||
    !hasExplicitPath ||
    url.hostname.toLowerCase().startsWith("al.")
  ) {
    return null;
  }

  const cleanUrl = new URL(url.href);
  cleanUrl.search = "";
  if (!cleanUrl.pathname.endsWith("/")) {
    cleanUrl.pathname += "/";
  }
  return `https://al.fanza.co.jp/?lurl=${encodeURIComponent(cleanUrl.href)}&af_id=${FANZA_AFFILIATE_ID}`;
}

function convertDigiketUrl(url: URL): string | null {
  if (
    !hasExactHost(url, ["digiket.com", "www.digiket.com"]) ||
    /\/AFID=[^/]+\/?/i.test(url.pathname)
  ) {
    return null;
  }

  const itemId = url.pathname.match(
    /^\/work\/show\/_data\/ID=([a-z0-9]+)\/?/i,
  )?.[1];
  if (itemId === undefined) {
    return null;
  }
  return `https://www.digiket.com/work/show/_data/ID=${itemId}/AFID=${DIGIKET_AFFILIATE_ID}/`;
}

/** 対象ECサイトの正規URLを運営アフィリエイトURLへ変換する。対象外・不正URLは入力をそのまま返す。 */
export function convertAffiliateUrl(value: string): string {
  const url = parseHttpUrl(value);
  if (url === null) {
    return value;
  }

  return (
    convertDlsiteUrl(value, url) ??
    convertDmmUrl(value, url) ??
    convertDigiketUrl(url) ??
    value
  );
}
